import { Coffee, Landmark, Compass, Check } from "lucide-react";

const TOGGLES = [
  { id: "bakeries", label: "Bakery stops", Icon: Coffee },
  { id: "museums", label: "Museums", Icon: Landmark },
  { id: "outside", label: "Outside the centre", Icon: Compass },
];

// Picker filters: show / hide whole groups of stops. Bakeries start hidden
// (there are a lot of them); museums and the neighbourhoods start visible.
export const PickerToggles = ({ value, onChange }) => (
  <div data-testid="planner-picker-toggles" className="mb-5 flex flex-wrap items-center gap-2">
    <span className="font-body font-800 text-[10px] tracking-[0.2em] text-black/40 mr-1">SHOW</span>
    {TOGGLES.map(({ id, label, Icon }) => {
      const on = !!value[id];
      return (
        <button
          key={id}
          type="button"
          role="switch"
          aria-checked={on}
          data-testid={`planner-toggle-${id}`}
          onClick={() => onChange({ ...value, [id]: !on })}
          className={`inline-flex items-center gap-1.5 font-body font-700 text-xs px-3 py-1.5 rounded-full border transition-all ${
            on ? "bg-black text-white border-black" : "bg-white text-black/55 border-zinc-300 hover:border-black hover:text-black"
          }`}
        >
          {on ? <Check size={12} strokeWidth={3} /> : <Icon size={12} />} {label}
        </button>
      );
    })}
  </div>
);
